import AxiosAPI from '@qualitas/libs';
import { AxiosResponse } from 'axios';

import { Contract, NewContractData } from '../Models';

export const ContractAPI = (baseURL: string |undefined, baseURLExternal: string |undefined, clientId: string) => {
    const apiConfig = {
        baseURL,
        clientId,
        isApp: true,
        hasUnderMaintenance: false
    };
    const externalAPI = AxiosAPI({ ...apiConfig, baseURL: baseURLExternal });
    const bookbuildingAPI = AxiosAPI({ ...apiConfig });

    const getShareTypes = () => {
        const serviceUrl = `/valuations-api/SharesType/GetSharesTypes`;
        return externalAPI.get(serviceUrl)
            .then((response: AxiosResponse) => response.data.data)
            .catch((error: any) => error);
    };

    const postContract = (data: NewContractData) => {
        const serviceUrl = `/bookbuilding-api/Contract`;
        return bookbuildingAPI.post(serviceUrl, data)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const updateContract = (data: Contract) => {
        const serviceUrl = `/bookbuilding-api/Contract/UpdateContract`;
        return bookbuildingAPI.put(serviceUrl, data)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const getContract = (contractId: number) => {
        const serviceUrl = `/bookbuilding-api/Contract/GetContract`;
        return bookbuildingAPI.get(serviceUrl, { params: { contractId } })
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const deleteContract = (contractId: number) => {
        const serviceUrl = `/bookbuilding-api/Contract/DeleteContract`;
        return bookbuildingAPI.delete(serviceUrl, { params: { contractId } })
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };
    const getAllContracts = () => {
        const serviceUrl = `/bookbuilding-api/Contract/GetAllContracts`;
        return bookbuildingAPI.get(serviceUrl)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const getPreviewContracts = () => {
        const serviceUrl = `/bookbuilding-api/Contract/GetPreviewContracts`;
        return bookbuildingAPI.get(serviceUrl)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const getAllContractsPage = (params: {
        skip?: number;
        take?: number;
        sort?: string;
        filter?: string;
        institutionId?: number;
        vehicleId?: number | null;
    }) => {
        const serviceUrl = `/bookbuilding-api/Contract/GetAllContractsPage`;
        return bookbuildingAPI.get(serviceUrl, { params })
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const getAllContractsHeaderFilterValues = (params: {
        field: string;
        filter?: string;
        institutionId?: number;
        vehicleId?: number | null;
    }) => {
        const serviceUrl = `/bookbuilding-api/Contract/GetAllContractsHeaderFilterValues`;
        return bookbuildingAPI.get(serviceUrl, { params })
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const getInRevisionContracts = () => {
        const serviceUrl = `/bookbuilding-api/Contract/GetInRevisionContracts`;
        return bookbuildingAPI.get(serviceUrl)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const rollbackContract = (contractId: number) => {
        const serviceUrl = `/bookbuilding-api/Contract/Rollback?contractId=${contractId}`;
        return bookbuildingAPI.post(serviceUrl)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const checkAllowedAmount = (VehicleId: number, idInstitution: number, commitment: number) => {
        const serviceUrl = `/bookbuilding-api/Contract/IsAllowedAmount`;
        return bookbuildingAPI.get(serviceUrl, { params: { VehicleId, idInstitution, commitment } })
            .then((response: AxiosResponse) => response.data.data)
            .catch((error: any) => error);
    };

    const getTransferValues = (idInstitution: number, idVehicle: number, idSharesType: number) => {
        const serviceUrl = `/bookbuilding-api/Contract/GetTransferValues`;
        return bookbuildingAPI.get(serviceUrl, { params: { idInstitution, idVehicle, idSharesType } })
            .then((response: AxiosResponse) => response.data.data)
            .catch((error: any) => error);
    };

		const saveExternalContract = (data: any) => {
		const serviceUrl = `/bookbuilding-api/ExternalContracts/SaveContractAndSendEmail`;
		return bookbuildingAPI.post(serviceUrl, data)
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

	const getContractByHash = (hash: string) => {
		const serviceUrl = `/bookbuilding-api/ExternalContracts/GetContractIdByHash?hash=${hash}`;
		return bookbuildingAPI.get(serviceUrl)
			.then((response: AxiosResponse) => response.data)	
			.catch((error: any) => error);
	};

	const getLastContractByIdUser = () => {
		const serviceUrl = `/bookbuilding-api/ExternalContracts/GetLastContractByIdUser`;
		return bookbuildingAPI.get(serviceUrl)
			.then((response: AxiosResponse) => response.data)
			.catch((error: any) => error);
	};

    return {
        postContract,
        updateContract,
        getContract,
        deleteContract,
        getAllContracts,
        getPreviewContracts,
        getAllContractsPage,
        getAllContractsHeaderFilterValues,
        getInRevisionContracts,
        rollbackContract,
        checkAllowedAmount,
        getShareTypes,
        getTransferValues,
		saveExternalContract,
		getContractByHash,
		getLastContractByIdUser
    };
};
